import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthLayout } from "@/components/app/AuthLayout";
import { TextField, PrimaryButton } from "@/components/app/TextField";
import { authApi, apiError } from "@/lib/api";
import { AUTH } from "@/constants/testIds";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await authApi.forgot(email);
      setSent(true);
    } catch (err) {
      setError(apiError(err.response?.data?.detail, err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Reset hasła"
      subtitle="Podaj adres e-mail. Wyślemy link do ustawienia nowego hasła."
      footer={
        <Link to="/logowanie" data-testid={AUTH.loginLink} className="font-medium text-brand-accent hover:underline">
          Wróć do logowania
        </Link>
      }
    >
      {sent ? (
        <div
          data-testid={AUTH.success}
          className="rounded-field border border-brand-line bg-brand-surface px-4 py-4 text-sm text-brand-sec"
        >
          Jeśli konto istnieje, wysłaliśmy instrukcję resetu hasła na podany adres.
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4" noValidate>
          {error && (
            <div data-testid={AUTH.error} className="rounded-field border border-red-500/40 bg-red-500/10 px-4 py-3 text-sm text-red-300">
              {error}
            </div>
          )}
          <TextField label="E-mail" type="email" testId={AUTH.emailInput} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="ty@firma.pl" required />
          <PrimaryButton type="submit" data-testid={AUTH.submitButton} disabled={loading}>
            {loading ? "Wysyłanie…" : "Wyślij link resetu"}
          </PrimaryButton>
        </form>
      )}
    </AuthLayout>
  );
}
